
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/app-bar.kpa`,
      template: `<nav class="main-nav" aria-label="Hauptnavigation" ref="nav">
        <!-- Burger Button für Mobile -->
        <button class="menu-toggle" aria-expanded="false" aria-controls="main-menu" ref="menu-toggle">
            <span class="sr-only">Menü öffnen</span>
            
            <!-- Hamburger Icon -->
            <svg aria-hidden="true" viewBox="0 0 24 24" width="24" height="24">
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
        </button>

        <!-- Hauptmenü -->
        <ul id="main-menu" class="menu-list" ref="menu">
            <li><a href="/home">Home</a></li>

            <li>
                <button
                    class="submenu-buttons has-submenu"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="submenu-about"
                    
                >
                    Über Uns
                </button>

                <ul id="submenu-about" class="submenu" aria-hidden="true">
                    <li><a href="/ueberuns/fachkompetenz"  tabindex="-1">Fachkompetenz</a></li>
                    <li><a href="/ueberuns/infrastruktur"  tabindex="-1">Infrastruktur</a></li>
                    <li><a href="/ueberuns/automatisierung"  tabindex="-1">Automatisierung</a></li>
                    <li><a href="/ueberuns/objektakte"  tabindex="-1">Objektakte</a></li>
                </ul>
            </li>

            <li>
                <button
                    class="submenu-buttons has-submenu"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="submenu-services"
                    
                >
                    Leistungen
                </button>

                <ul id="submenu-services" class="submenu" aria-hidden="true">
                    <li><a href="/leistungen/objektpflege"  tabindex="-1">Objektpflege</a></li>
                    <li><a href="/leistungen/hausmeisterservice"  tabindex="-1">Hausmeisterservice</a></li>
                    <li><a href="/leistungen/instandhaltung"  tabindex="-1">Instandhaltung</a></li>
                </ul>
            </li>

            <li><a href="/referenzen">Referenzen</a></li>
            <li><a href="/home#kontakt">Kontakt</a></li>
        </ul>
    </nav>`,
      style: `.main-nav {
  position: relative;
  z-index: 1000;
  background-color: #fff;
  border-bottom: 3px solid #64c16c;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  font-family: sans-serif;
}
.main-nav .menu-toggle {
  display: none;
  background: none;
  border: none;
  padding: 1rem;
  cursor: pointer;
}
.main-nav .menu-toggle svg {
  stroke: #2c4143;
  stroke-width: 2;
  fill: none;
}
.main-nav .sr-only {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.main-nav .menu-list {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0 1rem;
  height: 64px;
}
.main-nav .menu-list > li {
  position: relative;
  margin-left: 1.5rem;
}
.main-nav .menu-list > li a,
.main-nav .menu-list > li button.has-submenu {
  background: none;
  border: none;
  padding: 0.5rem 0;
  font-size: 1rem;
  color: #2c4143;
  text-decoration: none;
  cursor: pointer;
  box-shadow: none;
}
.main-nav .menu-list > li a:hover, .main-nav .menu-list > li a:focus,
.main-nav .menu-list > li button.has-submenu:hover,
.main-nav .menu-list > li button.has-submenu:focus {
  color: #64c16c;
  outline: none;
}
.main-nav .menu-list > li .submenu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 220px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  display: none;
}
.main-nav .menu-list > li .submenu.is-open {
  display: block !important;
}
.main-nav .menu-list > li .submenu li {
  margin: 0;
}
.main-nav .menu-list > li .submenu li a {
  display: block;
  padding: 0.5rem 1rem;
  color: #2c4143;
  text-decoration: none;
}
.main-nav .menu-list > li .submenu li a:hover, .main-nav .menu-list > li .submenu li a:focus {
  background-color: #f0f0f0;
  color: #64c16c;
}
.main-nav .menu-list > li:focus-within > .submenu, .main-nav .menu-list > li:hover > .submenu,
.main-nav .menu-list > li button[aria-expanded=true] + .submenu {
  display: block;
}
@media (max-width: 992px) {
  .main-nav .menu-toggle {
    display: block;
  }
  .main-nav .menu-list {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem;
    position: fixed;
    top: 0;
    left: 0;
    width: 260px;
    height: 100vh;
    background-color: #fff;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    box-shadow: 2px 0 12px rgba(0, 0, 0, 0.2);
    overflow-y: auto;
  }
  .main-nav .menu-list > li {
    margin: 0.5rem 0;
    width: 100%;
  }
  .main-nav .menu-list > li .submenu {
    position: relative;
    box-shadow: none;
    border-radius: 0;
    background-color: #f9f9f9;
    padding-left: 1rem;
  }
  .main-nav .menu-list > li .submenu.is-open {
    display: block !important;
  }
  .main-nav .menu-list > li .submenu[aria-hidden=true] {
    display: none;
  }
  .main-nav .menu-list > li .submenu[aria-hidden=false] {
    display: block;
  }
  .main-nav.is-open .menu-list {
    transform: translateX(0);
  }
}
.main-nav .menu-list a:focus-visible,
.main-nav .menu-list button:focus-visible {
  outline: 2px solid #64c16c;
  outline-offset: 2px;
}
@media (prefers-reduced-motion: reduce) {
  .main-nav *, .main-nav *::before, .main-nav *::after {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

@media (hover: hover) {
  .main-nav .menu-list > li:hover > .submenu {
    display: block;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {
        isOpen: false,
        lastFocused: null,
        liveRegion: null,
        currentUrl: null,
    },
    mounted() {
        this.liveRegion = document.createElement("div");
        this.liveRegion.setAttribute("aria-live", "polite");
        this.liveRegion.setAttribute("aria-atomic", "true");
        this.liveRegion.classList.add("sr-only");
        $refs['nav'].appendChild(this.liveRegion);
        this.currentUrl = window.location.pathname + window.location.hash;
        this.markActiveLink(this.currentUrl);
    },
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
            $refs['nav'].classList.toggle("is-open", this.isOpen);
            $refs['menu-toggle'].setAttribute("aria-expanded", this.isOpen);
            if (this.isOpen) {
                this.lastFocused = document.activeElement;
                const firstFocusable = $refs['menu'].querySelector("a, button");
                if (firstFocusable)
                    firstFocusable.focus();
                $refs['menu'].addEventListener("keydown", this.trapFocus);
                this.announce("Menü geöffnet");
            }
            else {
                $refs['menu'].removeEventListener("keydown", this.trapFocus);
                if (this.lastFocused)
                    this.lastFocused.focus();
                this.announce("Menü geschlossen");
            }
            $refs['menu'].setAttribute('aria-hidden', !this.isOpen);
        },
        toggleSubmenu(event) {
            const button = event.currentTarget;
            const submenuId = button.getAttribute("aria-controls");
            const submenu = document.getElementById(submenuId);
            const isCurrentlyOpen = button.getAttribute("aria-expanded") === "true";
            this.closeAllSubmenus();
            if (!isCurrentlyOpen) {
                this.openSubmenu(button);
                this.announce(\`$-{button.textContent.trim()} geöffnet\`);
            }
            else {
                this.announce(\`$-{button.textContent.trim()} geschlossen\`);
            }
        },
        setSubmenuTabIndex(submenu, enabled) {
            const links = submenu.querySelectorAll('a');
            links.forEach(link => {
                link.setAttribute('tabindex', enabled ? '0' : '-1');
            });
        },
        handleSubmenuKey(event) {
            const button = event.currentTarget;
            const submenuId = button.getAttribute("aria-controls");
            const submenu = document.getElementById(submenuId);
            if (event.key === "ArrowDown") {
                event.preventDefault();
                this.openSubmenu(button);
                const firstLink = submenu.querySelector("a");
                if (firstLink)
                    firstLink.focus();
            }
        },
        openSubmenu(button) {
            const submenuId = button.getAttribute("aria-controls");
            const submenu = document.getElementById(submenuId);
            button.setAttribute("aria-expanded", "true");
            submenu.setAttribute("aria-hidden", "false");
            submenu.classList.add("is-open");
            this.setSubmenuTabIndex(submenu, true);
            submenu.addEventListener("focusout", this.handleSubmenuFocusOut);
        },
        closeSubmenu(button) {
            const submenuId = button.getAttribute("aria-controls");
            const submenu = document.getElementById(submenuId);
            button.setAttribute("aria-expanded", "false");
            submenu.setAttribute("aria-hidden", "true");
            submenu.classList.remove("is-open");
            this.setSubmenuTabIndex(submenu, false);
            submenu.removeEventListener("focusout", this.handleSubmenuFocusOut);
            if (submenu.contains(document.activeElement)) {
                button.focus();
            }
        },
        closeAllSubmenus() {
            const buttons = $refs['menu'].querySelectorAll("button.has-submenu");
            buttons.forEach(button => {
                this.closeSubmenu(button);
            });
        },
        handleClickOutside(event) {
            if (!$refs['nav'].contains(event.target)) {
                this.closeAllSubmenus();
                if (this.isOpen) {
                    this.toggleMenu();
                    $refs['menu'].removeEventListener("keydown", this.trapFocus);
                }
            }
        },
        handleFocusOut(event) {
            requestAnimationFrame(() => {
                if (!$refs['menu'].contains(document.activeElement)) {
                    this.closeAllSubmenus();
                    if (this.isOpen)
                        this.toggleMenu();
                }
            });
        },
        handleSubmenuFocusOut(event) {
            const submenu = event.currentTarget;
            requestAnimationFrame(() => {
                const active = document.activeElement;
                const submenuId = submenu.getAttribute("id");
                const button = $refs['menu'].querySelector(\`button[aria-controls="$-{submenuId}"]\`);
                if (active === button) {
                    button.setAttribute("aria-expanded", "false");
                    submenu.setAttribute("aria-hidden", "true");
                    submenu.classList.remove("is-open");
                    this.setSubmenuTabIndex(submenu, false);
                    return;
                }
                if (!submenu.contains(active)) {
                    this.closeSubmenu(button);
                }
            });
        },
        globalEscape(event) {
            if (event.key === "Escape") {
                this.closeAllSubmenus();
                this.isOpen = false;
                $refs['nav'].classList.remove("is-open");
                $refs['menu-toggle'].setAttribute("aria-expanded", "false");
                $refs['menu'].removeEventListener("keydown", this.trapFocus);
                if (this.lastFocused)
                    this.lastFocused.focus();
                this.announce("Menü geschlossen");
            }
        },
        trapFocus(event) {
            if (event.key !== "Tab")
                return;
            const focusables = $refs['menu'].querySelectorAll('a[href], button:not([disabled])');
            const first = focusables[0];
            const last = focusables[focusables.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            }
            else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        },
        markActiveLink(currentPath) {
            const links = $refs['menu'].querySelectorAll("a[href]");
            links.forEach(link => {
                const href = link.getAttribute("href");
                if (!href)
                    return;
                if (currentPath === href || currentPath.startsWith(href + "/")) {
                    link.classList.add("active");
                    link.setAttribute("aria-current", "page");
                }
                else {
                    link.classList.remove("active");
                    link.removeAttribute("aria-current");
                }
            });
        },
        announce(message) {
            if (!this.liveRegion)
                return;
            this.liveRegion.textContent = '';
            requestAnimationFrame(() => {
                this.liveRegion.textContent = message;
            });
        },
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.globalEscape);
        $refs['menu'].removeEventListener("keydown", this.trapFocus);
        if (this.liveRegion && this.liveRegion.remove) {
            this.liveRegion.remove();
        }
    },
    events: [
        ['click', 'nav a[href]', function (event) {
                event.preventDefault();
                router.navigate(event.target.closest('a').getAttribute('href'));
            }],
        ['click', 'button.menu-toggle', function (event) {
                event.preventDefault();
                this.toggleMenu(event);
            }],
        ['click', 'button.submenu-buttons', function (event) {
                event.preventDefault();
                this.toggleSubmenu(event);
            }],
        ['keydown', 'button.submenu-buttons', function (event) {
                this.handleSubmenuKey(event);
            }],
        ['keydown', window, function (event) {
                this.globalEscape(event);
            }],
        ['popstate', window, function (event) {
                this.markActiveLink(window.location.pathname + window.location.hash);
            }],
        ['click', window, function (event) {
                this.handleClickOutside(event);
            }],
        ['focusout', '#main-menu', function (event) {
                this.handleFocusOut(event);
            }],
    ],
};
 })()`
    };
  